import React, { useState, useEffect } from "react";
import axios from "axios";
import { APIURL } from "../../../Config";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";

import moment from "moment/moment";

function Support() {
  const token = localStorage.getItem("token");

  const emailid = localStorage.getItem("emailId");
  const [employerSupports, setEmployerSupports] = useState([]);
  const [financeSupports, setFinanceSupports] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [message, setMessage] = useState("");
  const tableEmpSupport = React.useRef(null);
  const tableFinSupport = React.useRef(null);

  const [remarkMessage, setRemarkMessage] = useState({
    id: "",
    email: "",
    mobile: "",
    remark: "",
    user: "",
    ownerEmail: emailid,
  });

  useEffect(() => {
    getEmployerSupport();
    getFinanceSupport();
  }, []);
  const remarkChange = (e) => {
    setRemarkMessage({ ...remarkMessage, remark: e.target.value });
    setMessage(e.target.value);
  };
  const getEmployerSupport = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getsupport/Employer`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setEmployerSupports(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getFinanceSupport = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getsupport/financier `, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Finance response:::::::", response);
        setIsLoader(false);
        setFinanceSupports(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const closeIssueEmployer = (email, id) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/closeissue`, {
        method: "POST",
        data: {
          email: email,
          id: id,
          code: "Employer",
          ownerEmail: emailid,
        },
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        getEmployerSupport();
        toast.success("Close query successfully");
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const closeIssueFinancier = (email, id) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/closeissue`, {
        method: "POST",
        data: {
          email: email,
          id: id,
          code: "Financier",
          ownerEmail: emailid,
        },
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        getFinanceSupport();
        toast.success("Close query successfully");
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const handleSubmit = () => {
    console.log("message", message);
    axios
      .request(`${APIURL}/support`, {
        method: "POST",
        data: remarkMessage,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setShowModal(false);
        setMessage("");
        toast.success(response?.data);
        getEmployerSupport();
        getFinanceSupport();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-support" role="presentation">
            <button
              className="nav-link active tab-support "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Employer Support
            </button>
          </li>
          {/* <li className="nav-support" role="presentation">
            <button
              className="nav-link tab-support "
              id="finance-tab"
              data-bs-toggle="tab"
              data-bs-target="#finance"
              type="button"
              role="tab"
              aria-controls="finance"
              aria-selected="true"
            >
              Finance Support
            </button>
          </li> */}
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                <DownloadTableExcel
                  filename="EmpSupport"
                  sheet="users"
                  currentTableRef={tableEmpSupport.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>
                <div className="p-3 pt-4">
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>
                              Entry dt/time
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Employer name
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Contact name
                            </th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>Issue</th>
                            <th style={{ textAlign: "center" }}>
                              Resolution remark by us
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Close Ticket
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {employerSupports.map((support, index) => (
                            <tr key={support.id}>
                              <td>{index + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {support.date
                                  ? moment(support.date).format("DD-MM-YYYY")
                                  : ""}{" "}
                                {support.time
                                  ? moment(support.time).format("HH:mm:ss")
                                  : ""}
                              </td>

                              <td>
                                {support.empName}/{support.code}
                              </td>
                              <td>{support.contactName}</td>
                              <td>{support.mobile}</td>
                              <td>{support.issue}</td>
                              {/* <td>{support.remark}</td> */}
                              {support?.remarks === "" ||
                              support?.remarks === null ? (
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn btn-success"
                                      style={{ width: "150px" }}
                                      onClick={() => {
                                        setRemarkMessage({
                                          ...remarkMessage,
                                          id: support.id,
                                          email: support.email,
                                          mobile: support.mobile,
                                          remark: support.remark,
                                          user: "Employer",
                                        });
                                        setShowModal(true);
                                      }}
                                    >
                                      Reply
                                    </button>
                                  </div>
                                </td>
                              ) : (
                                <td>{support?.remarks}</td>
                              )}
                              <td>
                                <div className="d-flex justify-content-center">
                                  <button
                                    className="btn btn-danger"
                                    style={{ width: "150px" }}
                                    onClick={() => {
                                      closeIssueEmployer(
                                        support.email,
                                        support.id
                                      );
                                    }}
                                  >
                                    Close
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="finance"
            role="tabpanel"
            aria-labelledby="finance-tab"
          >
            <div className="pt-3">
              <div className="card">
                <DownloadTableExcel
                  filename="FinSupport"
                  sheet="users"
                  currentTableRef={tableFinSupport.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>
                <div className="p-3 pt-4">
                  {" "}
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Entry dt</th>
                            <th style={{ textAlign: "center" }}>Entry time</th>
                            <th style={{ textAlign: "center" }}>
                              Finance name/Code
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Contact name
                            </th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>Issue</th>
                            <th style={{ textAlign: "center" }}>
                              Resolution remark by us
                            </th>
                            <th style={{ textAlign: "center" }}>Status</th>
                            <th style={{ textAlign: "center" }}>
                              Close Ticket
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {financeSupports.map((support, index) => (
                            <tr key={support.id}>
                              <td>{index + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {support.date
                                  ? moment(support.date).format("DD-MM-YYYY")
                                  : ""}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {" "}
                                {support.time
                                  ? moment(support.time).format("HH:mm:ss")
                                  : ""}
                              </td>
                              <td>
                                {support.empName} / {support.code}
                              </td>
                              <td>{support.contactName}</td>
                              <td>{support.mobile}</td>
                              <td>{support.issue}</td>
                              {support?.remarks === "" ||
                              support?.remarks === null ? (
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn btn-success"
                                      style={{ width: "150px" }}
                                      onClick={() => {
                                        setRemarkMessage({
                                          ...remarkMessage,
                                          id: support.id,
                                          email: support.email,
                                          mobile: support.mobile,
                                          remark: support.remark,
                                          user: "Financier",
                                        });
                                        setShowModal(true);
                                      }}
                                    >
                                      reply
                                    </button>
                                  </div>
                                </td>
                              ) : (
                                <td>{support?.remarks}</td>
                              )}
                              <td>{support.status}</td>
                              <td>
                                <div className="d-flex justify-content-center">
                                  <button
                                    className="btn btn-danger"
                                    style={{ width: "150px" }}
                                    onClick={() => {
                                      closeIssueFinancier(
                                        support.email,
                                        support.id
                                      );
                                    }}
                                  >
                                    Close
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        style={{ background: "rgb(255 255 255 / 40%)" }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Remark</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <input
                            type="text"
                            value={message}
                            onChange={remarkChange}
                            style={{
                              width: "100%",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginTop: "10px",
                              fontSize: "18px",
                            }}
                          />
                          <div className="d-flex mt-3 justify-content-end">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => setShowModal(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success ml-2"
                              style={{
                                width: "100px",
                                background: "#66a725",
                              }}
                              onClick={() => handleSubmit()}
                            >
                              Submit
                            </button>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </div>
                  )}
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableEmpSupport}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry dt</th>
                        <th style={{ textAlign: "center" }}>Entry time</th>
                        <th style={{ textAlign: "center" }}>
                          Employer name/Code
                        </th>
                        <th style={{ textAlign: "center" }}>Contact name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Issue</th>
                        <th style={{ textAlign: "center" }}>
                          Resolution remark by us
                        </th>
                        <th style={{ textAlign: "center" }}>Status</th>
                        <th style={{ textAlign: "center" }}>Close Ticket</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employerSupports.map((support, index) => (
                        <tr key={support.id}>
                          <td>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {support.date
                              ? moment(support.date).format("DD-MM-YYYY")
                              : ""}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {" "}
                            {support.time
                              ? moment(support.time).format("HH:mm:ss")
                              : ""}
                          </td>
                          <td>
                            {support.empName}/{support.code}
                          </td>
                          <td>{support.contactName}</td>
                          <td>{support.mobile}</td>
                          <td>{support.issue}</td>
                          {/* <td>{support.remark}</td> */}
                          {support?.remarks === "" ||
                          support?.remarks === null ? (
                            <td>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn btn-success"
                                  style={{ width: "150px" }}
                                  onClick={() => {
                                    setRemarkMessage({
                                      ...remarkMessage,
                                      id: support.id,
                                      email: support.email,
                                      mobile: support.mobile,
                                      remark: support.remark,
                                      user: "Employer",
                                    });
                                    setShowModal(true);
                                  }}
                                >
                                  Reply
                                </button>
                              </div>
                            </td>
                          ) : (
                            <td>{support?.remarks}</td>
                          )}
                          <td>{support.status}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn btn-danger"
                                style={{ width: "150px" }}
                                onClick={() => {
                                  closeIssueEmployer(support.email, support.id);
                                }}
                              >
                                Close
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableFinSupport}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry dt</th>
                        <th style={{ textAlign: "center" }}>Entry time</th>
                        <th style={{ textAlign: "center" }}>
                          Finance name/Code
                        </th>
                        <th style={{ textAlign: "center" }}>Contact name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Issue</th>
                        <th style={{ textAlign: "center" }}>
                          Resolution remark by us
                        </th>
                        <th style={{ textAlign: "center" }}>Status</th>
                        <th style={{ textAlign: "center" }}>Close Ticket</th>
                      </tr>
                    </thead>
                    <tbody>
                      {financeSupports.map((support, index) => (
                        <tr key={support.id}>
                          <td>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {support.date
                              ? moment(support.date).format("DD-MM-YYYY")
                              : ""}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {" "}
                            {support.time
                              ? moment(support.time).format("HH:mm:ss")
                              : ""}
                          </td>
                          <td>
                            {support.empName} / {support.code}
                          </td>
                          <td>{support.contactName}</td>
                          <td>{support.mobile}</td>
                          <td>{support.issue}</td>
                          {support?.remarks === "" ||
                          support?.remarks === null ? (
                            <td>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn btn-success"
                                  style={{ width: "150px" }}
                                  onClick={() => {
                                    setRemarkMessage({
                                      ...remarkMessage,
                                      id: support.id,
                                      email: support.email,
                                      mobile: support.mobile,
                                      remark: support.remark,
                                      user: "Financier",
                                    });
                                    setShowModal(true);
                                  }}
                                >
                                  reply
                                </button>
                              </div>
                            </td>
                          ) : (
                            <td>{support?.remarks}</td>
                          )}
                          <td>{support.status}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn btn-danger"
                                style={{ width: "150px" }}
                                onClick={() => {
                                  closeIssueFinancier(
                                    support.email,
                                    support.id
                                  );
                                }}
                              >
                                Close
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
